import { ReactElement, useEffect, useState } from "react";
import useApiState, { api, ApiStateSetter } from "../../hooks/use-api-state";
import { IAppInfo } from "../../messages/IAppInfo";
import Loading from "../common/Loading";
import "../common/General.module.css";
import { useParams } from "react-router-dom";
import CodeReview from "./CodeReview";
import styles from "./CodeReview.module.css";
import { LabAccomplishment, ICodereviewContentResponse } from "../../messages/IGetUserContentResponse";


export default function CodeReviewWrapper(props: {
  appInfo: IAppInfo,
}): ReactElement {
  const { cohortCode, lmoduleId, reviewId } = useParams(); 
  const [getCodeReviewApiState, setGetCodeReviewApiState] = useApiState(false);

  const [message, setMessage] = useState<string|null>(null);
  const [userId, setUserId] = useState<string>();
  const [codeReviewContent, setCodeReviewContent] = useState<ICodereviewContentResponse | null>(null);
  const [labAccomplishment, setLabAccomplishment] = useState<LabAccomplishment | null>(null);


  useEffect(() => {
    document.title = "CTF code review";
    const searchParams = new URLSearchParams(window.location.search);
    const jwt = searchParams.get("jwt");
    if (cohortCode && lmoduleId && reviewId && jwt) {
      getCodereviewContent(cohortCode, lmoduleId, reviewId, jwt);
    }
  }, [cohortCode, lmoduleId, reviewId]);


  async function getCodereviewContent(cohortCode: string, lmoduleId: string, codereview_id: string, jwt: string) {
      try {
        let ret = await api.getCodeReviewContent(setGetCodeReviewApiState, cohortCode, lmoduleId, codereview_id, jwt);
        //console.log(`getCodereviewContent ret.enabled=${ret.enabled}`);
        if (ret.enabled) {
          setUserId(ret.user_id);
          setCodeReviewContent(ret);
          setLabAccomplishment(ret.lab_accomplishment ?? null);
          if (ret.lab_accomplishment && ret.lab_accomplishment.finished) {
            //console.log(`ret.getCodeReviewContent=${JSON.stringify(ret.lab_accomplishment)}`);
            if (!ret.lab_accomplishment.can_retry)
              setMessage("This code review challenge has been already submitted.");
          }
        } else {
          setMessage(ret.enabled_text ?? "The code review is not enabled.")
        }
      } catch (e: any) {
        console.error("Error fetching code review content:", e);
      }
  }


  async function CodeReviewSubmitHandler(
    index: number,
    /*setMessage: ((message: string | null) => void) | null,*/
    setSubmitApiState: ApiStateSetter)
  {
    if (!codeReviewContent) {
      return;
    }
    const cohortCode = (codeReviewContent.cohort_code ?? "").replaceAll("/", "_");
    const contentId = codeReviewContent.content_id.replaceAll("/", "_");
    //const contentKey = cohortCode + "/" + contentId
    const chapterId = codeReviewContent.chapter_id.replaceAll("/", "_");
    const moduleId = codeReviewContent.module?.id.replaceAll("/", "_");
    const lmoduleCode = codeReviewContent.lmodule_code.replaceAll("/", "_");
    //const moduleKey = chapterId + "/" + moduleId;
    const challengeId = codeReviewContent.module?.challenge_id ?? null;

    if (contentId && moduleId) {
      try {
        const resp = await api.submitCodeReview(
          setSubmitApiState,
          cohortCode,
          lmoduleCode,
          contentId,
          chapterId,
          moduleId,
          challengeId,
          index,
        );
        //console.log(`submitCodeReview resp=${JSON.stringify(resp)}`);
        if (index>=0) { // Calling this with index=-1 means that we want to redo the challenge (remove lab accomplishment)
          let message = null; // We cheat by adding the message to the lab accomplishment later, to pass it on to the CodeReview component
          if (resp.message) { // If there is a message, that prevails
            message = resp.message;
          }
          else {
            if (resp.status==="correct" || resp.status==="partial") {
              message = "Yes, that is correct!";
            }
            else if (resp.status==="failed") {
              message = "That was not the correct line." 
            }
          }
          if (setMessage && message) {
            setMessage(message);
          }

          if (resp.lab_accomplishment) {
            setLabAccomplishment(resp.lab_accomplishment);
          }
        }
        else {
          setLabAccomplishment(null);
        }
      } catch (e: Response | any) {
        console.error("Error submitting code review:", e);
      }
    }
  }

  return (
    <>
      <Loading isLoading={getCodeReviewApiState.isLoading}>
          <>
            {userId && codeReviewContent && codeReviewContent.module ? (
              <CodeReview
                appInfo={props.appInfo}
                userId={userId}
                cohortCode={codeReviewContent.cohort_code}
                contentId={codeReviewContent.content_id}
                chapterId={codeReviewContent.chapter_id}
                module={codeReviewContent.module}
                labAccomplishment={labAccomplishment}
                onSubmitted={CodeReviewSubmitHandler}
                codeReviewOnly={true}
                message={message}
              />
            ) : (
              <div className={styles.messageDiv}>
                <div className={styles.message}>{message}</div>
              </div>
            )}
          </>
      </Loading>
    </>
  );
}
